import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { DefaultButton, PrimaryButton, Stack } from '@fluentui/react';
import { Constants } from '@shared/utils/constants';
import { getResetFiltersAndSearchHref, getResetFiltersHref } from '@shared/utils/filterHelpers';
import { urlPush } from '@shared/routerHistory';
import { logTelemetry } from './noSearchResults';
export const getViewAllButtonText = (entityType, context, isConverged)=>{
    const viewTextMapping = {
        [Constants.EntityType.CloudsIndustry]: context.loc('NoSearchResults_ViewAllIndustryClouds', 'View all industry clouds'),
        [Constants.EntityType.Service]: isConverged ? context.loc('NoSearchResults_ViewAllServices_Converged', 'View all Professional Services') : context.loc('NoSearchResults_ViewAllServices', 'View all consulting services')
    };
    return viewTextMapping[`${entityType}`] || context.loc('NoSearchResults_ViewAllApps', 'View all apps');
};
export const clearSearchAndFilters = (changeSearchText, viewAllAppsUrl)=>{
    changeSearchText('');
    urlPush(viewAllAppsUrl);
};
export const renderViewAllAppsButton = (context, entityType, isPrimaryButton, currentPage, changeSearchText, isConverged)=>{
    const viewAllAppsClassName = 'ViewAllAppsCTA';
    const viewAllAppsText = getViewAllButtonText(entityType, context, isConverged);
    const viewAllAppsUrl = getResetFiltersAndSearchHref(context, entityType);
    const telemetryDetails = {
        message: 'View all apps button is pressed after the user got an empty search results page.',
        entityType
    };
    if (isPrimaryButton) {
        return /*#__PURE__*/ _jsx(PrimaryButton, {
            className: viewAllAppsClassName,
            text: viewAllAppsText,
            onClick: ()=>{
                logTelemetry(currentPage, Constants.Telemetry.ActionModifier.ViewAllButton, telemetryDetails);
                clearSearchAndFilters(changeSearchText, viewAllAppsUrl);
            },
            "data-bi-id": Constants.JsllCTAId.ViewAllButton,
            "data-bi-area": "Search"
        });
    }
    return /*#__PURE__*/ _jsx(DefaultButton, {
        className: viewAllAppsClassName,
        text: viewAllAppsText,
        onClick: ()=>{
            logTelemetry(currentPage, Constants.Telemetry.ActionModifier.ViewAllButton, telemetryDetails);
            clearSearchAndFilters(changeSearchText, viewAllAppsUrl);
        },
        "data-bi-id": Constants.JsllCTAId.ViewAllButton,
        "data-bi-area": "Search"
    });
};
export const renderClearFiltersButton = (context, entityType, currentPage)=>{
    const clearFiltersClassName = 'ClearFiltersCTA';
    const clearFiltersText = context.loc('NoSearchResults_ClearFilters', 'Clear filters');
    const resetFiltersUrl = getResetFiltersHref(context, entityType);
    const telemetryDetails = {
        message: 'Clear filters button is pressed after the user got an empty search results page.',
        entityType
    };
    return /*#__PURE__*/ _jsx(PrimaryButton, {
        className: clearFiltersClassName,
        text: clearFiltersText,
        onClick: ()=>{
            logTelemetry(currentPage, Constants.Telemetry.ActionModifier.ClearFilters, telemetryDetails);
            urlPush(resetFiltersUrl);
        },
        "data-bi-id": Constants.JsllCTAId.ClearFilters,
        "data-bi-area": "Search"
    });
};
export const NoSearchResultsButtons = ({ context, isSearch = false, isFilter = false, entityType = Constants.EntityType.App, currentPage = '', changeSearchText, isConverged = false })=>{
    if (isSearch && isFilter) {
        return /*#__PURE__*/ _jsxs(Stack, {
            horizontal: true,
            className: "NoSearchResultsCTAStack",
            tokens: {
                childrenGap: 's1'
            },
            children: [
                /*#__PURE__*/ _jsx(Stack.Item, {
                    align: "center",
                    children: renderClearFiltersButton(context, entityType, currentPage)
                }),
                /*#__PURE__*/ _jsx(Stack.Item, {
                    align: "center",
                    children: renderViewAllAppsButton(context, entityType, false, currentPage, changeSearchText, isConverged)
                })
            ]
        });
    } else if (isSearch) {
        return renderViewAllAppsButton(context, entityType, true, currentPage, changeSearchText, isConverged);
    }
    return renderClearFiltersButton(context, entityType, currentPage);
};
